import React, { useState } from 'react';
import { useUser, UserData } from '../../contexts/UserContext';
import { SearchIcon, UserIcon, LogInIcon, ShieldIcon, BuildingIcon, MailIcon, MapPinIcon } from 'lucide-react';
// Mock users for the admin panel
const MOCK_USERS: UserData[] = [{
  name: 'Alice Smith',
  email: 'alice@dealer.com',
  role: 'dealer',
  companyName: 'AgriTech',
  companyLogo: null,
  officialCountry: 'USA'
}, {
  name: 'Bob Jones',
  email: 'bob@customer.com',
  role: 'customer',
  companyName: 'FarmCorp',
  companyLogo: null,
  officialCountry: 'Canada'
}, {
  name: 'Carlos Ruiz',
  email: 'carlos@aisco.com',
  role: 'sales-manager',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'Spain'
}, {
  name: 'Diana Prince',
  email: 'diana@aisco.com',
  role: 'region-admin',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'UK'
}, {
  name: 'Elena Gomez',
  email: 'elena@dealer.com',
  role: 'dealer',
  companyName: 'Irrigo',
  companyLogo: null,
  officialCountry: 'Mexico'
}, {
  name: 'Frank Castle',
  email: 'frank@customer.com',
  role: 'customer',
  companyName: 'Punisher Farms',
  companyLogo: null,
  officialCountry: 'USA'
}, {
  name: 'George King',
  email: 'george@aisco.com',
  role: 'system-admin',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'USA'
}];
export function UsersManagement() {
  const {
    role: currentRole,
    impersonateUser
  } = useUser();
  const [searchQuery, setSearchQuery] = useState('');
  // Only system-admin and region-admin can use this feature
  const canImpersonate = currentRole === 'system-admin' || currentRole === 'region-admin';
  const filteredUsers = MOCK_USERS.filter(u => u.name.toLowerCase().includes(searchQuery.toLowerCase()) || u.email.toLowerCase().includes(searchQuery.toLowerCase()) || u.companyName.toLowerCase().includes(searchQuery.toLowerCase()) || u.role.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-558" data-mp="2bvhj5n6i2obx">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-559" data-mp="2bu6dfhthv6i6">
        <div data-id="element-560" data-mp="fqrwefp94l2z">
          <h2 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-561" data-mp="krz5ci34rqb8">
            <UserIcon className="text-blue-400" data-id="element-562" data-mp="kpuq53zs74vn" />
            Users Management
          </h2>
          <p className="text-blue-300 mt-1" data-id="element-563" data-mp="pjh3yzholet1">
            Manage users, roles, and impersonate accounts for support.
          </p>
        </div>

        <div className="relative w-full sm:w-72" data-id="element-564" data-mp="3szxpg6azmcwf">
          <SearchIcon size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-300/50" data-id="element-565" data-mp="3t18ra0kvhakw" />
          <input type="text" placeholder="Search users..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-2 text-sm text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-566" data-mp="1v7dvldfq4w3" />
        </div>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-567" data-mp="1m8ybzl44zcxw">
        <div className="overflow-x-auto" data-id="element-568" data-mp="1marin0er1x5w">
          <table className="w-full text-sm text-left" data-id="element-569" data-mp="1wbtt0co9qoy1">
            <thead className="text-xs text-blue-300 uppercase bg-white/5 border-b border-white/10" data-id="element-570" data-mp="1wepqy1049dmh">
              <tr data-id="element-571" data-mp="1rg4so74fd40o">
                <th className="px-6 py-4 font-medium" data-id="element-572" data-mp="1mmk0wwtfd69x">User</th>
                <th className="px-6 py-4 font-medium" data-id="element-573" data-mp="1mkz4f1njvd9f">Role</th>
                <th className="px-6 py-4 font-medium" data-id="element-574" data-mp="1ikf6hvv5k5m8">Company</th>
                <th className="px-6 py-4 font-medium" data-id="element-575" data-mp="1dm41pzjpslav">Country</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-576" data-mp="1dkaqe6y5pcwj">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-577" data-mp="18pnb8yp1luum">
              {filteredUsers.map((user, idx) => <tr key={idx} className="hover:bg-white/5 transition-colors" data-id="element-578" data-mp="13qagzsvudli0" data-mpi={idx}>
                  <td className="px-6 py-4" data-id="element-579" data-mp="zo74d0xfsav5">
                    <div className="flex items-center gap-3" data-id="element-580" data-mp="2y1yvxv22po2e">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center flex-shrink-0" data-id="element-581" data-mp="2y04mpe05zke5">
                        <span className="text-sm font-bold text-white" data-id="element-582" data-mp="313k476832449">
                          {user.name.split(' ').map(n => n[0]).join('').substring(0, 2)}
                        </span>
                      </div>
                      <div data-id="element-583" data-mp="2s2dqf4wtj7ep">
                        <p className="text-white font-medium" data-id="element-584" data-mp="2s58auwfu0s84">{user.name}</p>
                        <p className="text-blue-300/70 text-xs flex items-center gap-1 mt-0.5" data-id="element-585" data-mp="2w35y3tq1l48v">
                          <MailIcon size={10} data-id="element-586" data-mp="2ibrfho01r52c" />
                          {user.email}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-587" data-mp="28ghacrecqhkc">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-semibold uppercase tracking-wider bg-blue-500/20 text-blue-300 border border-blue-500/30" data-id="element-588" data-mp="2de929lezy3oj">
                      <ShieldIcon size={10} data-id="element-589" data-mp="24dkxzifenhou" />
                      {user.role.replace('-', ' ')}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-590" data-mp="1kskfaf8yxhnk">
                    <div className="flex items-center gap-2 text-blue-200" data-id="element-591" data-mp="1ktm1nfvfpqkl">
                      <BuildingIcon size={14} className="text-blue-400/70" data-id="element-592" data-mp="1fuiwlvfgfkcm" />
                      {user.companyName}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-593" data-mp="1ppszsmhl9xrz">
                    <div className="flex items-center gap-2 text-blue-200" data-id="element-594" data-mp="1pt8hlx2ndkx3">
                      <MapPinIcon size={14} className="text-blue-400/70" data-id="element-595" data-mp="23p2d9eeeuds9" />
                      {user.officialCountry}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-596" data-mp="2dgq2d8nhviqk">
                    {canImpersonate && <button onClick={() => impersonateUser(user)} className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/20 rounded-lg transition-colors text-xs font-medium" title={`Login as ${user.name}`} data-id="element-597" data-mp="28hltyk8e9p1a">
                        <LogInIcon size={14} data-id="element-598" data-mp="1f4m470t235ug" />
                        Login as
                      </button>}
                  </td>
                </tr>)}
              {filteredUsers.length === 0 && <tr data-id="element-599" data-mp="1k1mb1dxqccmm">
                  <td colSpan={5} className="px-6 py-8 text-center text-blue-300/70" data-id="element-600" data-mp="1o5bxnxuugk50">
                    No users found matching your search.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}